import {Expose} from 'class-transformer';
export class BrightcoveVideoApiModel {

  @Expose()
  videoId: string;

  @Expose()
  videoUrl: string;
}
